"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const app_1 = __importDefault(require("./app"));
const react_redux_1 = require("react-redux");
const index_1 = __importDefault(require("./store/index"));
const core_1 = require("@web3-react/core");
const providers_1 = require("@ethersproject/providers");
const react_router_dom_1 = require("react-router-dom");
const getLibrary = (provider) => {
    const library = new providers_1.Web3Provider(provider);
    library.pollingInterval = 12000;
    return library;
};
require("./index.scss");
ReactDOM.render(React.createElement(react_redux_1.Provider, { store: index_1.default },
    React.createElement(react_router_dom_1.BrowserRouter, null,
        React.createElement(core_1.Web3ReactProvider, { getLibrary: getLibrary },
            React.createElement(app_1.default, null)))), document.getElementById("root"));
